type BatchActionInputs = {
  actionType: string;
  isSelectedAll: boolean;
  selectedCount: number;
  totalObjects: number;
  page: string;
};

export function buildBatchActionProperties({
  actionType,
  isSelectedAll,
  selectedCount,
  totalObjects,
  page,
}: BatchActionInputs) {
  return {
    action_type: actionType,
    selected_count: isSelectedAll ? totalObjects : selectedCount,
    is_all_selected: isSelectedAll,
    page,
  };
}
